import React, { FC } from 'react'

import { IconEntertainmentProps } from './IconEntertainment.types'
import * as Styled from './styles/IconEntertainment.style'

import { nonThemeableRules } from '../../ruleSet'

const IconEntertainment: FC<IconEntertainmentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconEntertainmentProps['size'],
  isResponsive = false,
}: IconEntertainmentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M17.152 27.418 20 14.288c.212-.7.715-1.12 1.082-1.12a.5.5 0 0 1 .178.035 70.694 70.694 0 0 0 21.065 4.97c.215.017.86.027.86.027s-.28 1.775-.448 2.605c-.61 3.015-2.455 10.325-2.455 10.325-1.052 3.788-4.867 7.58-11.034 10.965a5.335 5.335 0 0 1-6.946-1.64c-3.45-4.98-5.202-9.435-5.15-13.037'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M17.152 27.413a4.295 4.295 0 0 1-.605-.228 29.34 29.34 0 0 1-4.402-2.527c-2.447-1.75-4-3.626-4.595-5.566L5.043 10.75c-.128-.545.045-1 .29-1.155a.403.403 0 0 1 .13-.045A55.929 55.929 0 0 0 21.29 4.8l.672-.3.375 1.157 2.813 8.968'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M23.383 32.645s.73 1.985 3.98 2.802c3.25.818 4.69-.622 4.69-.622'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M26.102 23.462h-2.235m11.218 3.433-1.58-1.582'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconEntertainment
